import React, {PropsWithChildren} from "react"
import "./card-icon.scss"

type Props = {
  title: React.ReactNode
  icon?: React.ReactElement
  badge?: React.ReactNode
}

export default function CardIcon({title, icon, badge, children}: PropsWithChildren<Props>) {
  return (
    <div className="card-icon box-shadow">
      {icon && <div className="card-icon__icon">{icon}</div>}
      {badge && <div className="card-icon__badge">{badge}</div>}
      <section className="card-icon__body">
        <h1 className="card-icon__title">{title}</h1>
        <div className="card-icon__text">{children}</div>
      </section>
    </div>
  )
}
